import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { store } from './store/Store';
import App from './App';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from '../authConfig.js';
import { MsalProvider } from '@azure/msal-react';
import { AuthProvider } from './components/context/AuthContext.js';
import { FormProvider } from './components/context/FormContext.js';

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders.
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
// const msalInstance = new PublicClientApplication(msalConfig);

// Default to using the first account if no account is active on page load
// if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
//   // Account selection logic is app dependent. Adjust as needed for different use cases.
//   msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
// }

// msalInstance.addEventCallback((event) => {
//   if (
//     (event.eventType === EventType.LOGIN_SUCCESS ||
//       event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS ||
//       event.eventType === EventType.SSO_SILENT_SUCCESS) &&
//     event.payload.account
//   ) {
//     msalInstance.setActiveAccount(event.payload.account);
//   }
// });

ReactDOM.createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    {/* <MsalProvider instance={msalInstance}> */}
      <FormProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </FormProvider>
    {/* </MsalProvider> */}
  </Provider>,
);
